import React from "react";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";
import FacebookIcon from "@material-ui/icons/Facebook";
import { useGAEventsTracker } from "../../util/gtag";
import { Grid } from "@material-ui/core";
import "../../styles/faq.scss";
import baseUrl from "../config/config";

export default function NewFooter(props) {
  const GAEventTracker = useGAEventsTracker(window.location.pathname);
  const GAEventTrackerQuesttionaire = useGAEventsTracker(
    window.location.pathname + "/Questionnaire"
  );
  const GAEventTrackerGetStarted = useGAEventsTracker(
    window.location.pathname + "/Get Started"
  );
  const GAEventTrackerContactUs = useGAEventsTracker(
    window.location.pathname + "/Contact Us"
  );
  const GAEventTrackerFooterLinkedIn = useGAEventsTracker(
    window.location.pathname + "/Linked In"
  );
  const GAEventTrackerFacebook = useGAEventsTracker(
    window.location.pathname + "/Facebook"
  );
  const GAEventTrackerInstagram = useGAEventsTracker(
    window.location.pathname + "/Instagram"
  );
  const GAEventTrackerYouTube = useGAEventsTracker(
    window.location.pathname + "/You Tube"
  );
  const GAEventTrackerTermsOfUse = useGAEventsTracker(
    window.location.pathname + "/Calque Terms Of Use"
  );
  const GAEventTrackerPrivacyPolicy = useGAEventsTracker(
    window.location.pathname + "/Calque Privacy Policy"
  );
  const GAEventTrackerHometownDisclosures = useGAEventsTracker(
    window.location.pathname + "/HomeTown Lenders Disclosures"
  );
  const GAEventTrackerSection = useGAEventsTracker(
    window.location.pathname + "/Section"
  );

  const handleScrollToWhyBbys = () => {
    const section = document.getElementById("whyworkwithus");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  };

  const handleScrollToHowItWorks = () => {
    const section = document.getElementById("trade");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  };

  const handleScrollToFaq = () => {
    const section = document.getElementById("faq");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  };

  return (
    <>
      <div
        className="top-padding-medium bottom-padding-medium row  mx-0 new_footer_padding"
        style={{
          backgroundColor: "#263E62",
        }}
      >
        <div className={`w-100 ${props?.partner?.url_path === "bbys"? '' : 'border-top'} new-footer-content-main-container`}>
          <Grid container spacing={2} style={{ paddingTop: "15px" }}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <div className="new_footer_have_more_qns w-100 text-md-left text-center">
                <div className="text-white ">
                  <span>Have more questions?</span>
                  <br />
                  <span>
                    Send an email to:{" "}
                    <a
                      className="mailto"
                      href={"mailto:info@calqueinc.com"}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      info@calqueinc.com
                    </a>
                  </span>
                </div>
                <div className="d-flex align-items-center pt-3">
                  <div className="pr-2">
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/calqueinc/"
                      onClick={(e) => {
                        GAEventTrackerFooterLinkedIn("Footer", 1);
                      }}
                    >
                      <img
                        src="/assets/images/linkedIn-icon.png"
                        alt="Linked In Icon"
                        width="50px"
                        height="50px"
                      />
                    </a>
                  </div>
                  <div className="pr-2">
                    <a
                      target="_blank"
                      href="https://www.facebook.com/CalqueInc"
                      onClick={(e) => {
                        GAEventTrackerFacebook("Footer", 1);
                      }}
                    >
                      <img
                        src="/assets/images/facebook-icon.png"
                        alt="Face Book Icon"
                        width="50px"
                        height="50px"
                      />
                    </a>
                  </div>
                  <div className="pr-2">
                    <a
                      target="_blank"
                      href="https://www.instagram.com/calqueinc/"
                      onClick={(e) => {
                        GAEventTrackerInstagram("Footer", 1);
                      }}
                    >
                      <img
                        src="/assets/images/instagram-icon.png"
                        alt="Instagram Icon"
                        width="50px"
                        height="50px"
                      />
                    </a>
                  </div>
                  <div className="pr-2">
                    <a
                      target="_blank"
                      onClick={(e) => {
                        GAEventTrackerYouTube("Footer", 1);
                      }}
                      href="https://www.youtube.com/channel/UCqR9EOg_H3vMuTb1lEmNjlg"
                    >
                      <img
                        src="/assets/images/youtube-icon.png"
                        alt="YouTube Icon"
                        width="50px"
                        height="50px"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <div className="new_footer_info text-white d-flex flex-column text-lg-left text-md-left text-sm-center">
                <h5 className="text-lg-left text-md-left text-sm-left info-text" style={{marginBottom: '15px'}}>
                  Information
                </h5>
                <div style={{ paddingTop: "5px" }} className="info-text">
                  <p
                    style={{ cursor: "pointer", fontSize: '14px' }}
                    onClick={handleScrollToWhyBbys}
                  >
                    WHY WORK WITH US?
                  </p>
                  <p
                    style={{ cursor: "pointer", fontSize: '14px' }}
                    onClick={handleScrollToHowItWorks}
                  >
                    HOW IT WORKS
                  </p>
                  <p style={{ cursor: "pointer", fontSize: '14px' }} onClick={handleScrollToFaq}>
                    FAQs
                  </p>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <div className="mt-sm-3 mt-md-0">
                {props.partner.partnership_logo_url ||
                props?.partner?.partner_licence_text ||
                props?.partner?.partner_address ? (
                  <>
                    <div className="partner-info d-flex ">
                      {props.partner.partnership_logo_url != null ? (
                        <img
                          src={`${baseUrl.mainUrl}${props?.partner?.partnership_logo_url}`}
                          alt="partnership logo"
                          height="105"
                          width="105"
                          className="partner-logo"
                        />
                      ) : (
                        ""
                      )}
                      <div className="partner-address text-white">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: props?.partner?.partner_licence_text,
                          }}
                        />
                        <p
                          style={{marginBottom:"0px",display : props?.partner?.url_path === "bbys" ? 'none' : 'block'}}
                          dangerouslySetInnerHTML={{
                            __html: props?.partner?.partner_name,
                          }}
                        />
                        <p
                          style={{marginBottom:"0px"}}
                          dangerouslySetInnerHTML={{
                            __html: props?.partner?.partner_address,
                          }}
                        />
                        {props?.partner?.nmls && 
                        <p>NMLS #{props?.partner?.nmls}</p>}
                        <p
                          dangerouslySetInnerHTML={{
                            __html: props?.partner?.partner_caution,
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div
                className="w-100 d-flex justify-content-center mt-3 footer_last_first_text mt-sm-5"
                style={{ height: "25px" }}
              >
                <p>
                  <a
                    target="_blank"
                    href={props.partner.calque_terms_of_use}
                    style={{ color: "#2b85c4" }}
                    onClick={(e) => {
                      GAEventTrackerTermsOfUse("Footer", 1);
                    }}
                  >
                    Calque Terms Of Use
                  </a>
                </p>
                <p>
                  <span className="px-3" style={{ color: "white" }}>
                    |
                  </span>
                </p>
                <p>
                  <a
                    target="_blank"
                    href={props.partner.calque_privacy_policy}
                    style={{ color: "#2b85c4" }}
                    onClick={(e) => {
                      GAEventTrackerPrivacyPolicy("Footer", 1);
                    }}
                  >
                    Calque Privacy Policy
                  </a>
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}
